import React, { Component } from 'react'
import classnames from "classnames"
import Button from './shared/Button/index'

import baseStyles from 'custom/base.styl';
import { connect } from "react-redux";
import { profileUpdateStages } from "../store/profile/actions";
import {get} from 'lodash'

class EssayWelcome extends Component {
  constructor(props) {
    super(props)

    this._handleOnClickUpdateStages = this._handleOnClickUpdateStages.bind(this)
  }

  _handleOnClickUpdateStages() {
    this.props.profileUpdateStages({essay_id: 1})
  }

  render() {
    const errors = get(this.props.error, 'errors', [])

    return (
      <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.testing)}>
        <div className={baseStyles.header}><h1 className={baseStyles.title}>Great Job!</h1></div>
        <p className={classnames(baseStyles.succeess_title)}>You have successfully completed our Language Test.</p>
        <p className={baseStyles.content_board__text}>You are now ready to start in our Sandbox environment. This is a
          training <br/> environment, where you will be able to complete 3 test essays and learn from <br/> sample good
          & bad essays. You will be able to learn and earn real money if you <br/> pass the tests successfully! <b>Here
            are the stages:</b></p>

        <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__succes)}>
          <li><b>Complete 1st test essay – earn $4</b><span className={baseStyles.light_text}>Check sample essays & compare with yours</span>
          </li>
          <li><b>Complete 2nd test essay – earn $8</b><span className={baseStyles.light_text}>Check sample essays & compare with yours</span>
          </li>
          <li><b>Complete 3rd essay – earn $8</b></li>
          <li><b>Your essay will be checked by our Freelancer Success Team</b></li>
        </ul>

        <p className={classnames(baseStyles.content_board__text, baseStyles.light_text)}>If successful, you get access
          to your account with real orders <br/> and be able to withdraw your money</p>

        {errors.map((item, key) => <div key={`essay-welcome-error-${key}`} className={classnames(baseStyles.text_danger, baseStyles.space_bottom)}>{item}</div>)}

        <Button onClick={this._handleOnClickUpdateStages}>Get Started</Button>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    error: state.profile.error
  }),
  (dispatch) => ({
    profileUpdateStages: (data) => (dispatch(profileUpdateStages(data))),
  })
)(EssayWelcome)



// WEBPACK FOOTER //
// ./src/components/PageEssayWelcome.js